import React, { useContext } from "react";

import { AsyncConfirmationModalContext } from "./AsyncConfirmationModalContext";
import { AsyncConfirmationModalWithIntent } from "./AsyncConfirmationModalWithIntent";
import { AsyncConfirmationModalWithNoIntent } from "./AsyncConfirmationModalWithNoIntent";

export const AsyncConfirmationModal = (): React.ReactElement | null => {
  const { state } = useContext(AsyncConfirmationModalContext);

  if (!state.isOpen) {
    return null;
  }

  const activeModal = state.stack[state.stack.length - 1];

  if (activeModal?.intent) {
    return <AsyncConfirmationModalWithIntent />;
  }

  return <AsyncConfirmationModalWithNoIntent />;
};
